import request from "../../utils/request";

export const state = {};

export const actions = {
  getCompanyImage({ dispatch, commit }, params) {
    return request({
      url: appUrl + "/api/company/image",
      params,
      callBack: (type, value) => {
        return value?.data?.data;
      },
    });
  },
};
